module.exports = __webpack_public_path__ + "img/out_stock_products.f8c385b8.svg";